import React, {useState, useEffect} from 'react'
import {v4 as uuid} from 'uuid'
import { ProductListContainer, ProductImage, ProductInfo, DeleteProduct, LoadContainer } from './style'
import config from "../../config/enviroment";
import Discount from '../../components/Discount'
import Spinner from '../Spinner';
import { useDispatch } from 'react-redux'
import {isSummaryPage} from '../../redux/actions/shoppingCartActions'
import CurrencyFormat from '../../utils/currencyFormat';
import {calculatePriceWithTax , returnProduct} from '../../utils/formatData'
import CornerRibbon from "react-corner-ribbon";
import {
    CartSidebarQuantityDot
  } from '../SummaryProductList/style';

interface ICartProductList{
    data: Array<any>,
    color: string,
    loading: boolean,
    show: boolean,
    onDelete: any,
}



export const CartProductList = ({data, color, loading, onDelete, show}: ICartProductList) => {
    
    const [currentPosition, setCurrentPosition] = useState<number>(0)
    const dispatch = useDispatch()
    const [items, setItems] = useState<any>([])



    useEffect(() => {
        const productsRefs= data.filter((item: any) => item.references && item.references.length > 0)
        const productsData = data.filter((item: any) => !(item.references && item.references.length > 0))
        if (productsRefs.length > 0) {
            productsRefs.map((product: any) => {
                product.references.map((itemRef: any) => {
                    itemRef.data = product.productData.references.find( (field: any) => field.id === itemRef.id)
                    productsData.push({...product, references: [itemRef]})
                })    
            })
        }
        setItems(productsData)

    }, [data])
    
    const mappingImgRef = (img: string, imgProduct: string) => {
        return img !== "" ? img : imgProduct
    }


    const returnProductQuantity = (product: any) => {
        if (product.references && product.references.length > 0) {
          return product.references[0].quantity;
        }
        return product.quantity;
      };
    
    return (

        <>
            { 
                items.map( (product: any, index: number ) => (             
                    <ProductListContainer key={uuid()}>
                        
                        {
                            
                            loading  && product.position === currentPosition ?

                            <LoadContainer>
                                <Spinner color={color}/>
                            </LoadContainer>

                            :
                            <>  
                                <div style={{display: 'flex','flex':"3"}}>
                                    <ProductImage>
                                        <img src={product.references && product.references.length > 0 ? mappingImgRef(product.references[0].data.img, product.productData.img[0]) : product.productData.img[0]} alt={product.references && product.references.length > 0 ? mappingImgRef(product.references[0].data.img, product.productData.img[0]) : product.productData.img[0]}/>
                                        {
                                            (product.references && product.references.length > 0 && product.references[0].data.discountRate > 0) || ((!product.references || product.references.length === 0) && product.productData.discountRate > 0) ?
                                            <CornerRibbon backgroundColor="#ff0000" fontColor="#f0f0f0" containerStyle={{}}>
                                            <span style={{fontFamily: 'Roboto', fontWeight: 700, fontSize: '1em'}}>
                                            {' '}{product.references && product.references.length > 0 ? product.references[0].data.discountRate : product.productData.discountRate}%off
                                            </span>
                                        </CornerRibbon>
                                            : null
                                        }
                                    </ProductImage>
                                    <ProductInfo style={{"position":"relative"}}>

                                        <CartSidebarQuantityDot color={color}>
                                        {returnProductQuantity(product)}
                                        </CartSidebarQuantityDot>
                                        <div className="cart-product-title">
                                        {product.productData.title}
                                        </div>
                                        { product.references && product.references.length > 0 && <div className="cart-product-subTitle">({product.references[0].data.title})</div>
                                        }
                                        {
                                            <div className="cart-product-normalPrice">
                                                <CurrencyFormat amount={product.references && product.references.length > 0 ? product.references[0].data.amount : product.productData.amount} />
                                            </div>
                                        }
                                    </ProductInfo>
                                </div>
                                { show &&
                                    <DeleteProduct color={color} style={{'flex':"1"}}>
                                        <svg data-src={`${config.urlMultimedia}/vende/landing-img/TrashIcon.svg`} onClick={ ()=> { 
                                            
                                            if(loading){
                                                return null
                                            }
                                            else{
                                                onDelete(product.position, items.length === 1, product.references && product.references.length > 0 ? product.references[0].id : "", product.id); 
                                                dispatch(isSummaryPage(false))
                                                setCurrentPosition(product.position)
                                            }                                                                                
                                            } }/>
                                            
                                    </DeleteProduct>
                                }
                            </>
                        }
                        
                    </ProductListContainer>
                ))
            }
        </>
    )
}
